import React from 'react';
import { useGameSettings } from '../hooks/useGameSettings';

interface GlobalMuteButtonProps {
    className?: string;
}

const GlobalMuteButton: React.FC<GlobalMuteButtonProps> = ({ className }) => {
    const { settings, updateSetting } = useGameSettings();

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                updateSetting('globalMute', !settings.globalMute);
            }}
            className={`fixed top-[calc(var(--shell-safe-top,0px)+16px)] left-[calc(var(--shell-safe-left,0px)+16px)] z-[9999] p-2.5 rounded-full bg-slate-900/50 hover:bg-slate-800/80 border border-slate-600 backdrop-blur-sm transition-all shadow-lg text-slate-300 hover:text-white ${className || ''}`}
            title={settings.globalMute ? "Р’РєР»СЋС‡РёС‚СЊ Р·РІСѓРє" : "Р’С‹РєР»СЋС‡РёС‚СЊ Р·РІСѓРє"}
        >
            {settings.globalMute ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" clipRule="evenodd" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                </svg>
            ) : (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                </svg>
            )}
        </button>
    );
};

export default GlobalMuteButton;
